export function extractInputsFromMetadata(metadata: CF.API.Metadata = {}): CF.API.Inputs.Input[] {
  if (Array.isArray(metadata.presetInputs)) {
    return metadata.presetInputs.map(
      (i) =>
        ({
          id: i.url,
          data: {
            [i.type]: {
              url: i.url,
            },
          } as Record<CF.API.InputType, { url: string }>,
          created_at: '2021-08-18T07:49:07.899233Z',
          modified_at: '2021-08-18T07:49:07.969561Z',
          status: {
            code: 30003,
            description: 'Download in progress',
          },
        } as CF.API.Inputs.Input),
    );
  }
  return [] as CF.API.Inputs.Input[];
}
